import { getAdjacencyWeightMod } from "./index62.js";
function getUnboundWeightMod({ plotEdges, adjacencyFactor = 1, siteBoundaryFactor = 1 }) {
	const func = getAdjacencyWeightMod({
		plotEdges,
		adjacencyFactor
	});
	return (lines) => {
		const adjWeights = func(lines);
		const weights = adjWeights.slice();
		for (let i = 0; i < adjWeights.length; i++) {
			if (!adjWeights[i]) continue;
			const prev = (weights.length + i - 1) % weights.length;
			const next = (i + 1) % weights.length;
			if (!weights[prev]) weights[prev] = siteBoundaryFactor;
			if (!weights[next]) weights[next] = siteBoundaryFactor;
		}
		return weights;
	};
}
export { getUnboundWeightMod };

//# sourceMappingURL=index66.js.map